import React from 'react';

import { Dashboard as DashboardView, UsersPage } from 'apps/admin';
import UserDetailPage from './Users/UserDetailPage';
import SubscriptionDetail from './Dashboard/SubscriptionDetail';
import InvitationDetail from './Dashboard/InvitationDetail';
import { Apps as AppsView } from 'apps/admin';
import { Items as ItemsView } from 'apps/admin';
import QuestionDetail from './Questions/QuestionDetail';
import AnswerDetail from './Answers/AnswerDetail';
// import ItemDetail from './Items/ItemDetail';
import CartView from './Ecommerce/Cart';
import CheckoutView from './Ecommerce/Checkout';
import OrderCompleteView from './Ecommerce/OrderComplete';
import DocketProgrammeList from './Docket/DocketProgrammeList';
import DocketAssignmentList from './Docket/DocketAssignmentList';
import DocketAssignmentDetail from './Docket/DocketAssignmentDetail';
import AuditLogPage from './AuditLog/AuditLogPage';
import TrialAdminPage from './Trials/TrialAdminPage';
import PlanAdminPage from './Plans/PlanAdminPage';
import BusinessTemplateAdminPage from './BusinessTemplates/BusinessTemplateAdminPage';
import AccountsPage from './Accounts/AccountsPage';
import AccountDetailPage from './Accounts/AccountDetailPage';
import DemoAccountsPage from './DemoEngine/DemoAccountsPage';
import DemoAccountDetailPage from './DemoEngine/DemoAccountDetailPage';
import DemoPersonasPage from './DemoEngine/DemoPersonasPage';

const adminRoutes = [
  {
    path: '/admin/dashboard',
    renderer: (params = {}): JSX.Element => <DashboardView {...params} />,
  },
  {
    path: '/admin/users',
    renderer: (params = {}): JSX.Element => <UsersPage {...params} />,
  },
  {
    path: '/admin/users/:id',
    renderer: (params = {}): JSX.Element => <UserDetailPage {...params} />,
  },
  {
    path: '/admin/dashboard/membership/:membershipid/subscription/:subscriptionid',
    renderer: (params = {}): JSX.Element => <SubscriptionDetail {...params} />,
  },
  {
    path: '/admin/dashboard/membership/:membershipid/subscription/:subscriptionid/invitation/:invitationid',
    renderer: (params = {}): JSX.Element => <InvitationDetail {...params} />,
  },
  {
    path: '/admin/dashboard/membership/:membershipid/subscription/:subscriptionid/add-invitation',
    renderer: (params = {}) => <InvitationDetail {...params} />,
  },
  {
    path: '/admin/dashboard/subscription/:subscriptionid/app/:appid',
    renderer: (params = {}): JSX.Element => <AppsView {...params} />,
  },
  {
    path: '/admin/dashboard/subscription/:subscriptionid/item/:itemid',
    renderer: (params = {}): JSX.Element => <ItemsView {...params} />,
  },
  {
    path: '/admin/dashboard/subscription/:subscriptionid/question/:questionid',
    renderer: (params = {}): JSX.Element => <QuestionDetail {...params} />,
  },
  {
    path: '/admin/dashboard/subscription/:subscriptionid/question/:questionid/answer/:answerid',
    renderer: (params = {}): JSX.Element => <AnswerDetail {...params} />,
  },
  {
    path: '/admin/dashboard/subscription/:subscriptionid/question/:questionid/add-answer',
    renderer: (params = {}): JSX.Element => <AnswerDetail {...params} />,
  },
  {
    path: '/admin/dashboard/ecommerce/cart',
    renderer: (params = {}): JSX.Element => <CartView {...params} />,
  },
  {
    path: '/admin/dashboard/ecommerce/checkout',
    renderer: (params = {}): JSX.Element => <CheckoutView {...params} />,
  },
  {
    path: '/admin/dashboard/ecommerce/order-complete',
    renderer: (params = {}): JSX.Element => <OrderCompleteView {...params} />,
  },
  {
    path: '/admin/docket',
    renderer: (params = {}): JSX.Element => <DocketProgrammeList {...params} />,
  },
  {
    path: '/admin/docket/programme/:programmeCode',
    renderer: (params = {}): JSX.Element => (
      <DocketAssignmentList {...params} />
    ),
  },
  {
    path: '/admin/docket/programme/:programmeCode/assignment/:assignmentId',
    renderer: (params = {}): JSX.Element => (
      <DocketAssignmentDetail {...params} />
    ),
  },
  {
    path: '/admin/audit-log',
    renderer: (params = {}): JSX.Element => <AuditLogPage {...params} />,
  },
  {
    path: '/admin/trials',
    renderer: (params = {}): JSX.Element => <TrialAdminPage {...params} />,
  },
  {
    path: '/admin/plans',
    renderer: (params = {}): JSX.Element => <PlanAdminPage {...params} />,
  },
  {
    path: '/admin/templates',
    renderer: (params = {}): JSX.Element => <BusinessTemplateAdminPage {...params} />,
  },
  {
    path: '/admin/accounts',
    renderer: (params = {}): JSX.Element => <AccountsPage {...params} />,
  },
  {
    path: '/admin/accounts/:id',
    renderer: (params = {}): JSX.Element => <AccountDetailPage {...params} />,
  },
  {
    path: '/admin/demo-engine/accounts',
    renderer: (params = {}): JSX.Element => <DemoAccountsPage {...params} />,
  },
  {
    path: '/admin/demo-engine/accounts/:id',
    renderer: (params = {}): JSX.Element => <DemoAccountDetailPage {...params} />,
  },
  {
    path: '/admin/demo-engine/personas',
    renderer: (params = {}): JSX.Element => <DemoPersonasPage {...params} />,
  },
];

export default adminRoutes;
